const Class4 = () => {
  return (
    <section className="lg:my-8">
      <div className="px-3 sm:px-4 lg:px-16 pt-8 lg:pb-2 bg-beige/60 mx-3 md:mx-8 lg:mx-20 rounded-lg shadow-lg ">
        <h1 className="text-2xl md:text-3xl lg:text-4xl text-center text-brown-700 font-bold mb-10 font-heading">
          Ganesha Idol Workshop
        </h1>
        <div className="w-full flex max-md:flex-col">
          {/* Portrait */}
          <div className="mr-5 flex-1 max-md:mx-auto">
            <img
              src="/images/class/ganeshadetail.jpg"
              alt="Artist Portrait"
              className="rounded-lg shadow-lg mx-auto lg:mx-0 object-cover w-full"
            />
          </div>
          {/* Text */}
          <div className="text-brown-700 lg:text-lg text-base lg:leading-relaxed leading-5 text-justify flex-[2] max-md:flex-1 font-para font-semibold">
            <p className="lg:mb-6 md:mb-5 mb-4 mt-4">
              Rebirth of Nature - Eco-Friendly Ganesha Idol Workshop<br />
              This Ganesh Chaturthi, celebrate with devotion and sustainability! Join us for a special workshop where you'll sculpt your own eco-friendly clay Ganesha idol embedded with seeds — a symbol of rebirth and harmony with nature. After the festival, immerse it in soil and watch your Ganesha transform into a living plant!
            </p>
            <p className="mb-6">
              Date: Saturday, 2nd August 2025<br />
              Time: 10:00 AM - 12:00 PM<br />
              Who Can Join: Kids (5+), Teens & Adults<br /><br />
              Fee: $40 per person (includes all materials)<br />
              Venue: Tvisarts Studio, Maylands<br />
              Younger kids can be accompanied by an adult.<br /><br />
              Limited spots available - experience creativity, culture, and care for the Earth in one meaningful celebration!
            </p>
            <div className="flex justify-center mt-8">
              <button className="text-brown-700 text-xl sm:text-2xl font-semibold shadow-inset w-[45%] max-sm:w-[50%] transition-all rounded-lg py-2 hover:shadow-xl hover:bg-beige">
                <a href="/#contactNav">Equire Now</a>
              </button>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center my-8">

        </div>
      </div>
      <img src="/images/class/ganeshadown.jpg" className="w-11/12 md:2/3 lg:w-3/5 my-8 mx-auto" />
    </section>
  );
};

export default Class4;